module.exports = __webpack_public_path__ + "img/app-empty-state.2613bfb1.png";